module.exports = __webpack_public_path__ + "assets/img/20220829.beb4a479.png";